@if (preventLightbox) {
    <gallery
    #galleryRef
    [id]="id"
    imageSize="cover"
    [items]="images"
    [dots]="true"
    [thumb]="false"
    [attr.data-testid]="testId"
    ></gallery>
}
@else {
    <gallery [gallerize]="'gallery'+context+id"
    #galleryRef
    [id]="id"
    imageSize="cover"
    [items]="images"
    [dots]="true"
    [thumb]="false"
    [attr.data-testid]="testId"
    ></gallery>
}

